import * as e6p from 'es6-promise';
(e6p as any).polyfill();
import 'isomorphic-fetch';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
const { Router, browserHistory } = require('react-router');
const { ReduxAsyncConnect } = require('redux-connect');
import { configureStore } from './app/redux/store';
import 'isomorphic-fetch';
import routes from './app/routes';
import { I18nextProviderWrapper } from 'containers';
import { AuthProvider } from 'containers/AccessControl/AuthProvider';
import CookieBanner from 'components/CookieBanner/index';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import { syncHistoryWithStore } from 'react-router-redux';

require('./app/styles/main.scss');

export const store = configureStore(browserHistory, window.__INITIAL_STATE__);
const persistor = persistStore(store);
const history = syncHistoryWithStore(browserHistory, store);
const connectedCmp = (props) => <ReduxAsyncConnect {...props} />;

ReactDOM.hydrate(
	<Provider store={store} key="provider">
		<I18nextProviderWrapper>
			<AuthProvider>
				<PersistGate loading={null} persistor={persistor}>
					<Router history={history} render={connectedCmp}>
						{routes}
					</Router>
					<CookieBanner />
				</PersistGate>
			</AuthProvider>
		</I18nextProviderWrapper>
	</Provider>,
	document.getElementById('app'),
);
